"use strict";

if (document.querySelector('.js-select')) {
  document.querySelectorAll('.js-select').forEach(function (item, index) {
    var choices = [];
    choices[index] = new Choices(item, {
      searchEnabled: true,
      searchChoices: true,
      searchResultLimit: 4,
      loadingText: 'Загрузка...',
      noResultsText: 'Результатов не найдено',
      noChoicesText: 'Нет вариантов на выбор',
      itemSelectText: 'Нажмите, чтобы выбрать',
      uniqueItemText: 'Можно добавлять только уникальные значения',
      customAddItemText: 'Можно добавлять только значения, соответствующие определенным условиям',
      searchPlaceholderValue: 'Начните вводить название'
    });
  });
}